<div class="quickbooks-callback">
  <div class="callback-card" *ngIf="!error">
    <mat-spinner diameter="48"></mat-spinner>
    <h1>Finishing your QuickBooks connection</h1>
    <p class="subtitle">One moment while we complete the setup&hellip;</p>
  </div>

  <div class="callback-card" *ngIf="error">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <h1>Connection not completed</h1>
    <p class="subtitle">{{ error }}</p>
    <button mat-raised-button color="primary" (click)="goBack()">Back to integrations</button>
  </div>
</div>
